var map = {
	"./android/detection": 983,
	"./androidtv/detection": 984,
	"./arris/detection": 985,
	"./hisense/detection": 986,
	"./lg/detection": 987,
	"./nagra/detection": 988,
	"./netrange/detection": 989,
	"./opera/detection": 990,
	"./polaroid/detection": 991,
	"./ps4/detection": 992,
	"./samsung/detection": 993,
	"./seirobotics/detection": 994,
	"./sony/detection": 995,
	"./stbcoship/detection": 996,
	"./stbcoship9108/detection": 997,
	"./stbhuawei/detection": 998,
	"./stbkaon/detection": 999,
	"./tizen/detection": 1000,
	"./web0s/detection": 1001,
	"./workstation/detection": 1002,
	"./workstationChafari/detection": 1003,
	"./zeasn/detection": 1004,
	"./zte/detection": 1005
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 982;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/detection$
// module id = 982
// module chunks = 0